<template>
  <div
    class="app-container"
    style="height: calc(100vh - 200px)"
    ref="container"
  >
    

    <el-card>
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            @click="handleAdd"
            v-if="admin=='admin'"
          >
            新增</el-button
          >
        </el-col>
      </el-row>
      <el-table :data="userlist" border style="width: 100%" max-height="850">
        <el-table-column type="index" width="50"> </el-table-column>
       
        <el-table-column prop="ztdm" label="账套代码"> </el-table-column>
        <el-table-column prop="ztmc" label="账套名称"> </el-table-column>
        <el-table-column prop="phone" label="手机号"> </el-table-column>
         <el-table-column prop="fsmm" label="发送密码"> </el-table-column>
        <el-table-column fixed="right" label="操作" v-if="admin=='admin'">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleClick(scope.row)"
              >修改</el-button
            >
            <el-button type="text" size="small" @click="delectClick(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 修改或添加用户 -->
    <el-dialog
      :title="title"
      :visible.sync="open"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="form.phone"
                placeholder="请输入手机号码"
                maxlength="11"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账套名称" prop="ztmc">
              <el-input
                v-model="form.ztmc"
                placeholder="请输入账套名称"
                maxlength="30"
              />
            </el-form-item>
          </el-col>
     
          <el-col :span="12">
            <el-form-item label="账套名称" prop="ztdm">
              <el-input
                v-model="form.ztdm"
                placeholder="请输入账套名称"
                maxlength="30"
              />
            </el-form-item>
          </el-col>
           <el-col :span="12">
            <el-form-item label="发送密码" prop="fsmm">
              <el-input
                v-model="form.fsmm"
                placeholder="请输入发送密码"
                maxlength="30"
              />
            </el-form-item>
          </el-col>
         
       
          <el-col :span="12">
            <el-form-item
              v-if="form.id == undefined"
              label="用户密码"
              prop="password"
            >
              <el-input
                v-model="form.password"
                placeholder="请输入用户密码"
                type="password"
                maxlength="20"
                show-password
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cansle">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import zt from '../api/zt'
export default {
  data() {
    return {
      ztid: null,
      token: "",
      userlist: [],
      title: "添加用户",
      open: false,
      form: {
        id:'',
        ztdm: undefined,
        
        fsmm:'',
        ztmc: undefined,
        password: undefined,
        phone: undefined,
       
       
      },
      // 角色选项
      roleOptions: [],
      //部门选项
      bmlist: [],
      // 表单校验
      rules: {
       
        phone: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
          {
            required: true,
            message: "手机号账号不能为空",
            trigger: "blur",
          },
        ],
      },
      admin:''
    };
  },
  methods: {
    handleAdd() {
      // console.log(1111111111);
      this.open = true;
      this.form = {
        id:'',
        ztdm: undefined,
        fsmm:'',
        ztmc: undefined,
        password: undefined,
        phone: undefined,
      };
    },
    // 转换时间格式
    formatDate(cellValue) {
      if (cellValue == null || cellValue == "") return "";
      var date = new Date(cellValue);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    //删除
    delectClick(item) {
      this.$confirm("是否删除" + item.ztmc + "？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async() => {
          
          let res =await zt.delzt(item.id)
             
              console.log(res);
              if (res.data.code == 1) {
                this.$message({
                  message: '删除账套信息成功',
                  type: "success",
                });
                this.ifZtadmin();
              }
              
         
        })
        .catch(() => {});
    },
    refreshStatus() {
      this.$forceUpdate();
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          //
            console.log(this.form);
            
            this.addzt(this.userlist)
              
           
          }
        
      });
    },
    async addzt(){
          let res = await zt.updateZt(this.form)
          console.log(res);
          if (res.data.code==1) {
            if (this.form.id) { this.$message({
                message: "修改账套信息成功",
                type: "success",
              });}else{
              this.$message({
                message: "新增账套信息成功",
                type: "success",
              });
            }
            
          } else {
              if (this.form.id) { this.$message({
                message: "修改账套信息失败",
                type: "warning",
              });}else{
              this.$message({
                message: "新增账套信息失败",
                type: "warning",
              });
            }
          }
          this.open = false;
          this.ifZtadmin();
    },
    handleClick(row) {
     
      console.log(row);
      this.open = true;
      this.form = row;
      console.log(this.form);
      // this.form.roleid =  row.Roles[0].rolename;
    },
    //关闭修改框
    cansle() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        userId: undefined,
        deptId: undefined,
        username: undefined,
        ztmc: undefined,
        password: undefined,
        phone: undefined,
        email: undefined,
        sex: undefined,
        status: "0",
        remark: undefined,
        postIds: [],
        roleIds: [],
      };
    },
    //获取用户列表
    async getlist() {
       let res = await zt.getzt()
       console.log(res.data.data);
        this.userlist.push(res.data.data)
        // this.userlist = res.data.data;
        // console.log(this.userlist);
    
    },
    //获取部门列表
    getbmlist() {
      this.axios.get(`/bmb/queryBmb`).then((res) => {
        console.log("bm", res);
        this.bmlist = res.data.data;
      });
    },
    //获取角色列表
    getjslist() {
      this.axios.get(`/roles/queryAllRoles`).then((res) => {
        console.log("js", res);
        this.roleOptions = res.data.data;
      });
    },
    //超级管理员角色列表
    async getAllzt(){
      const {data:res} = await zt.getAllzt()
      if(res.code==1){
         this.userlist=res.data
      }
    },
    ifZtadmin(){
      if(this.admin!="admin"){
    this.getlist();
    }else{
      this.getAllzt()
    }
    }
  },
  mounted() {
    this.ztid = sessionStorage.getItem("ztid");
    this.admin = sessionStorage.getItem("dm")
    this.ifZtadmin()
   
    // this.token=sessionStorage.getItem('token')
    // console.log(this.token);
    //  console.log('ztid',this.ztid);
    // this.axios({
    // headers:{
    //     'token':'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ7XCJpZFwiOi0xLFwicGFzc3dvcmRcIjpcImFkbWluXCIsXCJwaG9uZVwiOlwiMTg4MTg5ODA2OTBcIixcInp0aWRcIjoxfSIsImlhdCI6MTY1NDUwNzcxMH0.M98_b3iseNM8eDGv3iCM-ZxWr0EIyEsh0zeSk2wwHzs',
    //     'loginType':'admin'
    // },
    // url:'/users/queryUserByZtid',
    // mothod:'get'
    // }).then((res)=>{
    // console.log(res);
    // })
  },
};
</script>

<style scoped>
.crumbs-box {
  margin-bottom: 20px;
}
</style>